import { Card, CardContent } from "@/components/ui/card";
import { Package, Box, DollarSign, TrendingUp, Percent } from "lucide-react";

export const WebshopStats = ({ products }) => {
  const totalProducts = products.length;
  const totalStock = products.reduce((sum, p) => sum + (p.stock_quantity || 0), 0);
  const totalValue = products.reduce((sum, p) => sum + ((p.price || 0) * (p.stock_quantity || 0)), 0);
  const lowStock = products.filter(p => (p.stock_quantity || 0) < 5).length;
  const activeDiscounts = products.filter(p => p.discount_enabled).length;

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
      <Card className="bg-gradient-to-br from-blue-500/20 to-blue-600/10 border-blue-500/30">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <Package className="w-8 h-8 text-blue-400" />
            <div>
              <p className="text-[#94A3B8] text-sm">Products</p>
              <p className="text-2xl font-bold text-white">{totalProducts}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card className="bg-gradient-to-br from-green-500/20 to-green-600/10 border-green-500/30">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <Box className="w-8 h-8 text-green-400" />
            <div>
              <p className="text-[#94A3B8] text-sm">Total Stock</p>
              <p className="text-2xl font-bold text-white">{totalStock}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card className="bg-gradient-to-br from-purple-500/20 to-purple-600/10 border-purple-500/30">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <DollarSign className="w-8 h-8 text-purple-400" />
            <div>
              <p className="text-[#94A3B8] text-sm">Inventory Value</p>
              <p className="text-xl font-bold text-white">{totalValue.toLocaleString()} NOK</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card className="bg-gradient-to-br from-orange-500/20 to-orange-600/10 border-orange-500/30">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <TrendingUp className="w-8 h-8 text-orange-400" />
            <div>
              <p className="text-[#94A3B8] text-sm">Low Stock</p>
              <p className="text-2xl font-bold text-white">{lowStock}</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-gradient-to-br from-pink-500/20 to-pink-600/10 border-pink-500/30">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <Percent className="w-8 h-8 text-pink-400" />
            <div>
              <p className="text-[#94A3B8] text-sm">Active Discounts</p>
              <p className="text-2xl font-bold text-white">{activeDiscounts}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
